import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";
import BaseModel from "../../Models/BaseModel";
import MaritimeBoundariesStore from "./Store";

const MaritimeBoundaryDataMapping = {
	EEZ: {
		name: "properties.GeoName",
		country: "properties.Territory1",
		countryISO3: "properties.ISO_Ter1",
		lng: "properties.x_1",
		lat: "properties.y_1",
		esriId: "properties.FID"
	},
	TTW: {
		name: "properties.GeoName",
		country: "properties.Territory1",
		countryISO3: "properties.ISO_Ter1",
		lng: "properties.x_1",
		lat: "properties.y_1",
		esriId: "properties.FID"
	}
};
class MaritimeBoundary extends BaseModel {
	constructor(feature, boundaryType) {
		super(MaritimeBoundaryDataMapping[boundaryType], {
			name: "Unknown",
			country: "N/A",
			countryISO3: "",
			lng: 0,
			lat: 0
		});

		this.data = feature;
		this.type = boundaryType;

		this.loadState = writable(LoadState.INIT);
		this.visible = writable(false);

		this.visible.subscribe((visible) => {
			if (visible && get(this.loadState) === LoadState.INIT) {
				MaritimeBoundariesStore.actions.loadSingle(this);
			}
			// else if (!visible && get(this.loadState) === LoadState.LOADED) {
			// 	MaritimeBoundariesStore.actions.updateFeatureCollection();
			// }
		});
	}

	get name() {
		return this.get("name");
	}

	get country() {
		return this.get("country");
	}

	get lng() {
		return this.get("lng");
	}

	get lat() {
		return this.get("lat");
	}

	get esriId() {
		return this.get("esriId");
	}

	get uniqId() {
		return this.type + "_" + this.esriId;
	}

	asFeature() {
		return this.data;
	}
}

export default MaritimeBoundary;
